import { render } from "./NotificationDetail.vue?vue&type=template&id=69ba3a00&scoped=true"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"

import "./NotificationDetail.vue?vue&type=style&index=0&id=69ba3a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ba3a00"]])

export default __exports__